import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import {deleteOneNewsMedia, fetchOneNews} from "../../store/news/actions";
import MediasService from '../../services/medias';
import MediaList from "../../components/media/MediaList/MediaList";
import withTranslation from "../../hoc/withTranslation";
import {EDIT_NEWS_MEDIA_PAGE} from "../../constants/routes";

export class NewsMimeMediaListPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        news: PropTypes.object
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.newsId)
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.entity === null) {
            this.fetchOneNews(nextProps.app.id, nextProps.match.params.newsId);
        }
    }

    // Fetch

    fetch(appId = null, newsId = null) {
        this.fetchApplication(appId);
        this.fetchOneNews(appId, newsId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchOneNews(appId = null, newsId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;

            if (app && news) {
                this.props.fetchOneNews(app, news, this.props.lang);
            }
        }
    }

    // Handlers

    handleEditMedia = (media) => {
        let url = EDIT_NEWS_MEDIA_PAGE
            .replace(':appId', this.props.app.id)
            .replace(':newsId', this.props.news.id)
            .replace(':mediaId', media.id);
        this.props.history.push(url);
    };

    handleDeleteMedia = (media) => {
        if (this.props.app && this.props.news) {
            this.props.deleteOneNewsMedia(this.props.app.id, this.props.news.id, media);
        }
    };

    // Render

    render() {
        let shortMime = this.props.match.params.shortMime;

        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.news) {
            return <Loading paper={false}/>;
        } else {
            let medias = MediasService.sortedMediasForShortMime(this.props.news.medias, shortMime);
            let mimeDisplayName = MediasService.displayNameForShortMime(shortMime);

            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media_plural')} / {mimeDisplayName} - {this.props.news.title}</h3>
                    <MediaList
                        title={mimeDisplayName}
                        medias={medias}
                        handleDeleteMedia={this.handleDeleteMedia}
                        handleEditMedia={this.handleEditMedia}
                    />
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.apps.pending || state.points.pending || state.trails.pending,
        error: state.points.error || state.apps.error || state.trails.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        user: state.auth.content,
        news: state.news.currentNews
    };
}

export default connect(mapStateToProps, {
    fetchApp,
    fetchOneNews,
    deleteOneNewsMedia
})(withTranslation(NewsMimeMediaListPage));



// WEBPACK FOOTER //
// src/containers/news/NewsMimeMediaListPage.js